import { Box } from '@mui/material';
import type { Estimate } from 'api/types';
import DataTable from 'components/NewLayout/Table';
import PaperContainer from 'components/PaperContainer';
import type { PaginationDataType } from '..';
import Analytics from './Analytics';
import EstimateSearchHeader from './EstimateSearchHeader';

type ColumnType = (
  | {
      name: string;
      prop: string;
      data: (row) => JSX.Element | string;
    }
  | {
      prop: string;
      name: string;
      data: string;
    }
)[];

export default function EstimatesList({
  isLoading,
  estimatesListColumns,
  estimatesList,
  totalCount,
  setPaginationData,
  setSearchStr,
  setCreateJob,
  setInitiateEstimateDrawer
}: {
  isLoading: boolean;
  estimatesListColumns: ColumnType;
  estimatesList: Estimate[];
  totalCount: number;
  setPaginationData: (data: PaginationDataType) => void;
  setSearchStr: (value: string) => void;
  setCreateJob: (data: string | null) => void;
  setInitiateEstimateDrawer: (status: boolean) => void;
}) {
  const getCreateJobData = (data: string) => {
    console.log(data);
    setCreateJob(data);
  };

  const handleSearchData = (e) => {
    setSearchStr(e.target.value);
  };

  return (
    <>
      <Box className="active-inactive-admin-ws-div" sx={{ marginBottom: '20px', flexWrap: 'wrap' }}>
        <Box sx={{ marginX: '10px', marginY: '5px' }}>
          <Analytics title={'Open Estimate'} value={2} backgroundColor={'#c32051'} />
        </Box>
        <Box sx={{ marginX: '10px', marginY: '5px' }}>
          <Analytics title={'Completed Estimates'} value={2} backgroundColor={'#335d87'} />
        </Box>
      </Box>
      <PaperContainer>
        <Box>
          <EstimateSearchHeader
            sendCreateJobData={getCreateJobData}
            onChange={handleSearchData}
            setInitiateEstimateDrawer={setInitiateEstimateDrawer}
          />
        </Box>
        <br />
        <DataTable
          items={estimatesList}
          columns={estimatesListColumns}
          loading={isLoading}
          totalCount={totalCount}
          serverSidePagination
          dataSource={(pageNumber, pageSize, searchText) =>
            setPaginationData({ pageNumber, pageSize, searchText })
          }
        />
      </PaperContainer>
    </>
  );
}
